import { type FC, useEffect, useState } from 'react';

import { styled } from '@cofenster/web-components';

const HiddenImage = styled('img')({
  width: 0,
  height: 0,
  position: 'absolute',
});

export const TrackView: FC<{ video: HTMLVideoElement | null; videoId: string }> = ({ video, videoId }) => {
  const [played, setPlayed] = useState(false);

  useEffect(() => {
    if (!video) return;
    const handler = () => setPlayed(true);
    video.addEventListener('play', handler);
    return () => video.removeEventListener('play', handler);
  }, [video]);

  if (!played) return null;

  return <HiddenImage src={`/api/a/play/${videoId}`} alt="" aria-hidden="true" />;
};
